import { render } from "./AddQuotation.vue?vue&type=template&id=7243412c&scoped=true"
import script from "./AddQuotation.vue?vue&type=script&lang=js"
export * from "./AddQuotation.vue?vue&type=script&lang=js"

import "./AddQuotation.vue?vue&type=style&index=0&id=7243412c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7243412c"]])

export default __exports__